import { render } from "./FullDayView.vue?vue&type=template&id=a6ff31f2"
import script from "./FullDayView.vue?vue&type=script&lang=js"
export * from "./FullDayView.vue?vue&type=script&lang=js"

import "./FullDayView.vue?vue&type=style&index=0&id=a6ff31f2&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__